import { render, staticRenderFns } from "./ModeratorPromotionTab.vue?vue&type=template&id=4f049fae&"
import script from "./ModeratorPromotionTab.vue?vue&type=script&lang=js&"
export * from "./ModeratorPromotionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports